'use strict';

module.exports = function (o) {
  return o != undefined && typeof o.then === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/promise/thenable.js
// module id = 43
// module chunks = 10